"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _SearchField = _interopRequireDefault(require("./SearchField.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SearchField = _ref => {
  let {
    keyword,
    placeholder,
    InputProps,
    TextFieldProps,
    onSearch
  } = _ref;
  const css = (0, _SearchField.default)();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)(css.root, "mco-filter-item__search")
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    fullWidth: true,
    placeholder: placeholder,
    value: keyword,
    InputProps: {
      ...InputProps
    },
    onChange: onSearch
  }, TextFieldProps)));
};
var _default = exports.default = SearchField;